import { HttpInterceptor, HttpRequest, HttpHandler, HttpUserEvent, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { UserService } from "../shared/user.service";
import { Page1Service } from "../page1/page1.service";
import 'rxjs/add/operator/do';
import { Injectable } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private router: Router, private route: ActivatedRoute) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        //let u = window.location.pathname;
        let u = (window.location.pathname + window.location.search);
        let param = '';
        //if (u && u.toLowerCase().startsWith('/lpi/')) {
        if (u && u.toLowerCase().startsWith('/lpi?')) {
            //let p = u.split('/');
            let p = u.split('=');
            if (p && p.length>0) {
                //param = '/lpi/' + p[p.length-1];
                param = p[p.length-1];
            }
        }
        if (u && u.toLowerCase().startsWith('/new-document-profit/')) {
          param = u;
        }

        if (req.headers.get('No-Auth') == "True")
            return next.handle(req.clone());

        if (localStorage.getItem('userToken') != null) {
            const clonedreq = req.clone({
                headers: req.headers.set("Authorization", "Bearer " + localStorage.getItem('userToken'))
            });
            return next.handle(clonedreq)
                .do(
                succ => { },
                err => {
                    if (err.status === 401)
                        this.router.navigateByUrl('/login?lp=' + param);
                }
                );
        }
        else {
            if (!window.location.pathname.startsWith("/equipmentSign")) {
                this.router.navigateByUrl("/login?lp=" + param);
              }
              return next.handle(req);
              
            // this.router.navigateByUrl('/login?lp=' + param);
        }
    }
}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/auth/auth.interceptor.ts